module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"phoneNumber":"Phone Number","placeholder":"Select country"},"ar":{"phoneNumber":"رقم الهاتف","placeholder":"اختر البلد"}}')
  delete Component.options._Ctor
}
